import React from 'react';
import PropTypes from 'prop-types';
import { usePrefs } from 'wsm-common-data';
import { setClassNames } from '@ddc/classnames-js';
import FacetCount from './FacetCount';
import ColorSwatch from './ColorSwatch';

const Facet = ({
	facetLabel,
	inputType,
	facetValue,
	facetCount,
	groupId,
	isDisabled,
	onChange,
	handleSelect,
	isTopLevel
}) => {
	const { showFacetCounts, facetDisplay } = usePrefs();
	const isNestedCheckbox =
		facetDisplay === 'nested' && inputType === 'checkbox';
	const showNestedDivider = isNestedCheckbox && !isTopLevel;
	const isSelected = handleSelect(facetValue);

	const getSwatchColor = (group, value) => {
		if (value === 'ALL') return null;
		if (
			group === 'normalExteriorColor' ||
			(group === 'normalInteriorColor' && value)
		) {
			return value;
		}
		return null;
	};
	const swatchColor = getSwatchColor(groupId, facetValue);

	return (
		<li
			className={`${inputType} ${
				isNestedCheckbox
					? `my-0${showNestedDivider ? ' border-bottom' : ''}`
					: 'mb-lg-4'
			}`}
			key={`${groupId}-${facetValue}`}
		>
			<label
				className={setClassNames([
					isDisabled && 'disabled',
					isNestedCheckbox && 'd-block w-100 pl-0',
					showNestedDivider ? 'py-4' : isNestedCheckbox && 'py-3'
				])}
				htmlFor={`${groupId}-${facetValue}`}
			>
				<input
					type={inputType}
					name={groupId}
					value={facetValue}
					id={`${groupId}-${facetValue}`}
					onChange={(e) => onChange(e, groupId)}
					checked={isSelected}
					disabled={isDisabled}
					className={
						isNestedCheckbox && !isSelected ? 'sr-only' : undefined
					}
				/>
				<span className="facet-list-facet-label-text-container">
					{swatchColor && <ColorSwatch color={swatchColor} />}
					<span className="facet-list-facet-label-text">
						{facetLabel}
						{showFacetCounts === 'true' && facetCount && (
							<FacetCount count={facetCount} />
						)}
					</span>
				</span>
			</label>
		</li>
	);
};

Facet.propTypes = {
	inputType: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	isDisabled: PropTypes.bool.isRequired,
	facetLabel: PropTypes.string.isRequired,
	facetValue: PropTypes.string.isRequired,
	groupId: PropTypes.string.isRequired,
	facetCount: PropTypes.number,
	handleSelect: PropTypes.func.isRequired,
	isTopLevel: PropTypes.bool
};

Facet.defaultProps = {
	facetCount: undefined,
	isTopLevel: false
};

export default Facet;
